module.exports = __webpack_public_path__ + "static/img/aqzs26.dc9cb339.jpg";